import React, { useState } from 'react';

// components
import Header from '../../components/Header/Header';
import Breadcrumbs from '../../components/Breadcrumbs';

// icons
import icon from '../../brand/generated/sidebar/equipment.svg';
import axios from '../../plugins/axios';
import { useNavigate, useParams } from 'react-router-dom';
import HookForm from '../../components/HookForm/HookForm';
import InputNumeric from '../../components/Inputs/Input/InputNumeric';
import SelectEquipmentType from '../../components/Selects/SelectEquipmentType';
import StrToNum from '../../utils/StrToNum';
import SelectCity from '../../components/Selects/SelectCity';

const formStyles = {
  equipment: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a a a' 'b b c c' 'e e e e' 'd d d d'` },
  other: { display: 'grid', gap: '20px' },
};

const AddEquipments = ({ close, id, header = true }) => {
  const navigate = useNavigate();

  const [equipment, setEquipment] = useState([
    {
      type: 'input',
      name: 'title',
      label: 'ÐÐ°Ð·Ð²Ð°Ð½Ð¸Ðµ',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾Ð³Ð¾ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ñ',
      value: null,
      style: { gridArea: 'a' },
      rules: { required: true },
    },
    {
      component: SelectEquipmentType,
      name: 'typeId',
      label: 'ÐÐ´Ð¸Ð½Ð¸ÑÐ° Ð¸Ð·Ð¼ÐµÑÐµÐ½Ð¸Ñ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      rules: { required: true },
    },
    {
      component: InputNumeric,
      name: 'count',
      label: 'ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾',
      value: null,
      rules: { required: true },
    },
    {
      component: InputNumeric,
      name: 'price',
      label: 'Ð¦ÐµÐ½Ð°, KZT',
      placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ ÑÐµÐ½Ñ',
      value: null,
      style: { gridArea: 'c' },
      rules: { required: true },
    },
    {
      component: SelectCity,
      name: 'cityId',
      label: 'ÐÐ¾ÑÐ¾Ð´',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      style: { gridArea: 'e' },
      rules: { required: true },
    },
    {
      value: null,
      name: 'comment',
      label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ Ð´Ð¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ð¸',
      placeholder: 'ÐÑÑÐ°Ð²ÑÑÐµ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹ Ð¾Ð± Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ð¸',
      style: { gridArea: 'd' },
    },
  ]);
  const addEquipment = (values) => {
    axios
      .post('/api/crm/equipments/add', {
        equipment: {
          title: values?.title,
          containerId: id,
          count: StrToNum(values?.count),
          price: StrToNum(values?.price),
          typesId: values?.typeId?.value,
          cityId: values?.cityId?.value,
        },
        comment: values?.comment,
      })
      .then((res) => {
        close();
      })
      .catch((error) => {});
  };

  return (
    <>
      {header && (
        <>
          <Header title="ÐÐ¾Ð²Ð¾Ðµ Ð´Ð¾Ð¿.Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ" icon={icon} />
          <Breadcrumbs navigate={'/equipments'} link={'ÐÐºÑÐµÑÑÑÐ°ÑÑ'} currentPage={'ÐÐ¾Ð²ÑÐµ Ð°ÐºÑÐµÑÑÑÐ°ÑÑ'} />
        </>
      )}

      <HookForm
        inputs={equipment}
        handlerSetState={setEquipment}
        title={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾Ð¼ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ð¸'}
        grid={formStyles.equipment}
        border
        onSubmit={addEquipment}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'}
      />
    </>
  );
};

export default AddEquipments;
